var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-wrapper section-title animated-fast fadeInDown"},[_c('div',[_c('i',{staticClass:"mr-3",class:_vm.activeItem.icon}),_vm._v(_vm._s(_vm.tr(_vm.activeItem.translate, _vm.activeItem.name)))])])}
var staticRenderFns = []

export { render, staticRenderFns }